import { useMemo } from "react";
import type { IScheduleChangeSliceComparatorListItem } from "@b2bportal/core-flights";
import {
  getSliceDestinationCity,
  getSliceScheduleChangeKey,
} from "@b2bportal/core-utilities";
import type { IFlightScheduleChangeDetailsProps } from "@tenant/flights";

export const useFlightScheduleChangeDetails = (
  props: IFlightScheduleChangeDetailsProps
) => {
  return useMemo(() => {
    const {
      itinerary,
      scheduleChangeDataModel: { context },
    } = props;
    const { slices } = itinerary.travelItinerary;
    const sliceComparatorList: IScheduleChangeSliceComparatorListItem[] = [];

    for (let i = 0; i < slices.length; i += 1) {
      const originalSlice = slices[i];
      const sliceChangeKey = getSliceScheduleChangeKey(originalSlice);
      const sliceChange = props.scheduleChangeDiffs.changes[sliceChangeKey];

      if (sliceChange == null) continue;

      const destCity = getSliceDestinationCity(originalSlice, context.airports);

      sliceComparatorList.push({
        originalSlice,
        sliceChange,
        destinationCity: destCity,
        sliceKey: sliceChangeKey,
      });
    }

    return {
      context: {
        sliceComparatorList,
      },
    };
  }, [props]);
};

export type IFlightScheduleChangeDetailsData = ReturnType<
  typeof useFlightScheduleChangeDetails
>;
